module.exports = __webpack_public_path__ + "img/foreign_hover.6817f79.png";